export default "__VITE_ASSET__80c6e568__"